import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faTrash } from '@fortawesome/free-solid-svg-icons';

import { adminPaneGrey } from 'common/constants/colors';
import { AttributeNameValPair } from '../interfaces';

interface Props {
    item: AttributeNameValPair;
    isSelected?: boolean;
    onClick?: () => void;
    onDelete?: () => void;
}

const PaneItem = ({
  item,
  isSelected,
  onClick,
  onDelete,
}: Props) => (
  <div
    onClick={onClick}
    role="button"
    style={{
      alignItems: 'center',
      background: isSelected ? adminPaneGrey : '',
      borderRadius: '5px',
      display: 'flex',
      fontSize: '16px',
      justifyContent: 'space-between',
      margin: '10px 10px',
      padding: '10px 0',
    }}
  >
    <div style={{ marginLeft: '30px' }}>
      <span style={{ fontWeight: 'bold' }}>{item.name}</span>
      {`: ${item.value }`}
    </div>
    <div style={{ display: 'flex' }}>
      {onDelete && (
        <div
          onClick={e => { e.preventDefault(); onDelete() }}
          role="button"
          style={{ marginRight: '15px' }}
        >
          <FontAwesomeIcon icon={faTrash} size="sm" />
        </div>
      )}
      {onClick && (
        <div style={{ marginRight: '15px' }}>
          <FontAwesomeIcon icon={faCaretRight} />
        </div>
      )}
    </div>
  </div>
);

export default PaneItem;
